import styled from "styled-components/macro";

export const StyledCurrentHighlights = styled.div`
  position: absolute;
  bottom: -40px;
  right: -20px;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  z-index: 1;
  color: #fff;
  font-size: 12px;
  font-weight: 500;
  width: 70px;
  height: 40px;
  background-color: rgba(79, 109, 85, 0.9);

  ${(props) => props.theme.breakpoints.down("lg")} {
    right: -35px;
  }
`;
